export const CLAVE_NAV_ESCRITORIO = 'cqinv.nav-escritorio.v1';

export interface EstadoNavEscritorio {
  readonly compacto: boolean;
  readonly grupos: Readonly<Record<string, boolean>>;
}

const VACIO: EstadoNavEscritorio = { compacto: false, grupos: {} };

export function leerEstadoNavEscritorio(): EstadoNavEscritorio {
  try {
    const crudo = localStorage.getItem(CLAVE_NAV_ESCRITORIO);
    if (!crudo) return VACIO;
    const leido = JSON.parse(crudo) as { compacto?: unknown; grupos?: unknown };
    return {
      compacto: leido.compacto === true,
      grupos: leido.grupos && typeof leido.grupos === 'object' ? (leido.grupos as Record<string, boolean>) : {},
    };
  } catch {
    return VACIO;
  }
}

export function guardarEstadoNavEscritorio(estado: EstadoNavEscritorio): void {
  localStorage.setItem(CLAVE_NAV_ESCRITORIO, JSON.stringify(estado));
}
